import { SxProps } from "@mui/material";

export const InputWrapper: SxProps = {
  width: "100%",
  justifyContent: "space-between",
};
export const HalfInputWrapper: SxProps = {
  width: "50%",
  justifyContent: "space-between",
};

export const LabelStyle: SxProps = {
  fontWeight: 500,
  fontSize: "14px",
  lineHeight: "150%",
  mb: "10px",
  color: "text.primary",
  "& .MuiFormLabel-asterisk": {
    color: "#F05252",
  },
};

export const LabelStyle2: SxProps = {
  fontWeight: 500,
  fontSize: "14px",
  lineHeight: "150%",
  mb: "10px",
  color: "text.primary",
  "& .MuiFormLabel-asterisk": {
    color: "#F05252",
  },
};

export const requiredStyles: SxProps = {
  "&::after": {
    content: '"*"',
    color: "red",
    marginLeft: "3px",
  },
};

export const optionEllipsisStyle = {
  display: "block",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
} as const;
